import styled from 'styled-components'

import { Image as DefaultImage } from '../Image'

export const Image = styled(DefaultImage)`
	width: ${({ size }) => size * 1.25}px;
	border-radius: ${({ isRounded }) => (isRounded ? 3 : 0)}px;
`
